var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgSampleBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 60,
    viewBox: "0 0 220 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_23)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.94267,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.46241,
    width: 3.94267,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2903,
    width: 4.7312,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.624,
    width: 4.7312,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.3118,
    width: 4.7312,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.6591,
    width: 4.7312,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.033,
    width: 4.7312,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.614,
    width: 4.7312,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.269,
    width: 4.7312,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.381,
    width: 4.7312,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.857,
    width: 4.7312,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.1757,
    width: 2.3656,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.2195,
    width: 4.7312,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.7563,
    width: 2.3656,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.4087,
    width: 2.3656,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.415,
    width: 4.7312,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.51,
    width: 3.15413,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.477,
    width: 2.3656,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.129,
    width: 2.3656,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.711,
    width: 2.3656,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.954,
    width: 3.15413,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6953,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.51958,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5591,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.241,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.183,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.997,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.442,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.125,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.882,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.385,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.9284,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.327,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.6382,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.4879,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.5808,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.65,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1038,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.685,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.302,
    width: 1.57707,
    height: 59.9999,
    fill: "#10141A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 60,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSampleBarcode);
export default __webpack_public_path__ + "static/media/img_sample_barcode.e11c196688a8f0097babbf3a416c33f4.svg";
export { ForwardRef as ReactComponent };